module.exports = __webpack_public_path__ + "img/icon-sync.9104a4f3.svg";